//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    name: 'umall-search',
    props: {
        value: {
            type: String,
            default: ''
        },
        results: {
            type: Array,
            default() {
                return []
            }
        },
        remoteMethod: Function,
        selectChange: Function,
        placeholder: {
            type: String,
            default: '請輸入地址信息搜索（2個字以上）'
        },
        noDataText: {
            type: String,
            default: '暫時未能查出相關地址'
        },
        // 最小输入触发远程搜索数字
        miniLimit: {
            type: Number,
            default: 0
        }
    },
    watch: {
        results (val) {
            this.isLoading = false
            this.show = true
        },
        value(val) {
            this.currentValue = val
        }
    },
    data() {
        return {
            show: false,
            isLoading: false,
            currentValue:''
        }
    },
    methods: {
        onClickingMask() {
            this.show = false
        },
        searchInput(params) {
            console.log(params)
            let length = this.currentValue.length
            if (length >= this.miniLimit) {
                if (typeof this.remoteMethod == 'function' && !this.isLoading) {
                    this.isLoading = true
                    this.remoteMethod(this.currentValue)
                }
            }
        },
        handleSelectChange(params) {
            this.show = false
            if (typeof this.selectChange == 'function') {
                this.selectChange(params)
            }
        }
    },
    computed: {
        isShowResult() {
            if (this.results.length) {
                return true
            }
            return false
        }
    }
}
